let overflow = null

const ITEM      = 'item',
      SEPARATOR = 'separator'


export class BasicContext {
	public static dom(elem = ''):any {

		return document.querySelector('.basicContext ' + elem)

	}

	public static  Valid(item:any = {}) {

		let emptyItem = (Object.keys(item).length===0 ? true : false)

		if (emptyItem===true)     item.type    = SEPARATOR
		if (item.type==null)      item.type    = ITEM
		if (item.class==null)     item.class   = ''
		if (item.visible!==false) item.visible = true
		if (item.icon==null)      item.icon    = null
		if (item.title==null)     item.title   = 'Undefined'

		// Add disabled class when item disabled
		if (item.disabled!==true) item.disabled = false
		if (item.disabled===true) item.class += ' basicContext__item--disabled'

		// Item requires a function when
		// it's not a separator and not disabled
		if (item.fn==null && item.type!==SEPARATOR && item.disabled===false) {

			console.warn(`Missing fn for item '${ item.title }'`)
			return false

		}

		return true

	}

	public static BuildItem = function(item, num) {
		if(item==null||item==false)
			return;
		let html = '',
			span = ''

		// Parse and validate item
		if (BasicContext.Valid(item)===false) return ''

		// Skip when invisible
		if (item.visible===false) return ''

		// Give item a unique number
		item.num = num

		// Generate span/icon-element
		if (item.icon!==null) span = `<span style="margin:0" class='basicContext__icon ${ item.icon }'></span>`

		if(item.url!=null)span=`<img src="${item.url}"/>`


		if(item.subMenu)
		{

		}

		// Generate item
		if (item.type===ITEM) {

			html = `
		       <tr class='basicContext__item ${ item.class }'>
		           <td style="padding-left: 0" class='basicContext__data' data-num='${ item.num }'><div style="width: 24px;display: inline-block;text-align: center;">${ span }</div>${ item.title }</td>
		       </tr>
		       `

		} else if (item.type===SEPARATOR) {

			html = `
		       <tr class='basicContext__item basicContext__item--separator'></tr>
		       `

		}

		return html

	}

	public static  Build(items) {

		let html = ''

		html += `
	        <div class='basicContextContainer'>
	            <div class='basicContext'>
	                <table>
	                    <tbody>
	        `

		items.forEach((item, i) =>{ let txt= BasicContext.BuildItem(item, i);if(txt!=null)html +=txt;})

		html += `
	                    </tbody>
	                </table>
	            </div>
	        </div>
	        `

		return html

	}


	public static GetNormalizedEvent = function(e:any = {}) {

		let pos = {
			x : e.clientX,
			y : e.clientY
		}

		if (e.type==='touchend' && (pos.x==null || pos.y==null)) {

			// We need to capture clientX and clientY from original event
			// when the event 'touchend' does not return the touch position

			let touches = e.changedTouches

			if (touches!=null&&touches.length>0) {
				pos.x = touches[0].clientX
				pos.y = touches[0].clientY
			}

		}

		// Position unknown
		if (pos.x==null || pos.x < 0) pos.x = 0
		if (pos.y==null || pos.y < 0) pos.y = 0

		return pos

	}

	public static GetPosition = function(e, context) {

		// Get the click position
		let normalizedEvent = BasicContext.GetNormalizedEvent(e)

		// Set the initial position
		let x = normalizedEvent.x,
			y = normalizedEvent.y

		// Get size of browser
		let browserSize = {
			width  : window.innerWidth,
			height : window.innerHeight
		}

		// Get size of context
		let contextSize = {
			width  : context.offsetWidth,
			height : context.offsetHeight
		}

		// Fix position based on context and browser size
		if ((x + contextSize.width) > browserSize.width)   x = x - ((x + contextSize.width) - browserSize.width)
		if ((y + contextSize.height) > browserSize.height) y = y - ((y + contextSize.height) - browserSize.height)

		// Make context scrollable and start at the top of the browser
		// when context is higher than the browser
		if (contextSize.height > browserSize.height) {
			y = 0
			context.classList.add('basicContext--scrollable')
		}

		// Calculate the relative position of the mouse to the context
		let rx = normalizedEvent.x - x,
			ry = normalizedEvent.y - y

		return { x, y, rx, ry }

	}

	public static  Bind(item:any = {}) {
		if (item.fn==null)        return false
		if (item.visible===false) return false
		if (item.disabled===true) return false

		BasicContext.dom(`td[data-num='${ item.num }']`).onclick       = item.fn;
		BasicContext.dom(`td[data-num='${ item.num }']`).oncontextmenu = item.fn;

		return true

	}

	public static Show(items, e, fnClose=null, fnCallback=null) {

		// Build context
		let html = BasicContext.Build(items)

		// Add context to the body
		document.body.insertAdjacentHTML('beforeend', html)

		// Save current overflow and block scrolling of site
		if (overflow==null) {
			overflow = document.body.style.overflow
			document.body.style.overflow = 'hidden'
		}

		// Cache the context
		let context:any = BasicContext.dom()

		// Calculate position
		let position = BasicContext.GetPosition(e, context)

		// Set position
		context.style.left            = `${ position.x }px`
		context.style.top             = `${ position.y }px`
		context.style.transformOrigin = `${ position.rx }px ${ position.ry }px`
		context.style.opacity         = 1

		// Close fn fallback
		if (fnClose==null) fnClose = BasicContext.Close;

		// Bind click on background
		context.parentElement.onclick       = fnClose
		context.parentElement.oncontextmenu = fnClose

		// Bind click on items
		items.forEach(BasicContext.Bind)

		// Do not trigger default event or further propagation
		if (typeof e.preventDefault === 'function')  e.preventDefault()
		if (typeof e.stopPropagation === 'function') e.stopPropagation()

		// Call callback when a function
		if (typeof fnCallback === 'function') fnCallback()

		return true

	}

	public static  Visible() {

		let elem = BasicContext.dom()

		if (elem==null || elem.length===0) return false
		else                               return true

	}

	public static Close() {

		if (BasicContext.Visible()===false) return false

		let container = document.querySelector('.basicContextContainer')

		container.parentElement.removeChild(container)

		// Reset overflow to its original value
		if (overflow!=null) {
			document.body.style.overflow = overflow
			overflow = null
		}

		return true

	}
}






